import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import WarehouseListLayer from "../components/WarehouseListLayer";

const WarehousePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout pageTitle='Warehouse'>
        {/* WarehouseListLayer */}
        <WarehouseListLayer />
      </MasterLayout>
    </>
  );
};

export default WarehousePage;
